// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader-2vZWXCFyNI9GAgkd0JFo_d"};